const translations = {
	page_title: "Produits",
	product_types: {
		scpi: "SCPI",
		private_equity: "Private Equity",
		natural_assets: "Actifs Naturels",
		diversification: "Diversification",
	},
	completed: {
		label: "Complet",
	},
	not_available: {
		label: "Pas de mapping",
	},
	incompleted: {
		label: "Incomplet",
		tooltip: "Produit non digitalisable : Uploader les documents de souscription pour ce produit.",
	},
	table: {
		columns: {
			status: "Statut",
			product: "Produit",
			distribution: "Taux de distribution N-1",
			distribution_n2: "Taux de distribution N-2",
			distribution_frequency: "Fréquence de distribution",
			capitalization: "Capitalisation",
			occupation: "Taux d'occupation financier",
			report: "Report à nouveau (jours)",
			category: "Catégorie",
		},
	},
	history_table: {
		columns: {
			data: "Donnée",
			modificationDate: "Date de modification",
			creator: "Responsable",
		},
	},
};

export default translations;
